import { createKsStore, type KsStoreHook } from '@siclop/kstone-vue'
import { SalaryGridLevel } from '../models/SalaryGridLevel'
import { SalaryGridLevelForm } from '../forms/SalaryGridLevelForm'
import { SalaryGridLevelFilter } from '../filters/SalaryGridLevelFilter'
import { SalaryGridLevelService } from '../services/SalaryGridLevelService'

export const useSalaryGridLevelStore: KsStoreHook<SalaryGridLevel, SalaryGridLevelForm, SalaryGridLevelFilter> = createKsStore({
  id: 'salaryGridLevels',
  modelClass: SalaryGridLevel,
  formClass: SalaryGridLevelForm,
  filterClass: SalaryGridLevelFilter,
  service: SalaryGridLevelService,
  labelField: (item) => item.label || `Échelon ${item.level}`,
  signalREventName: 'SalaryGridLevelModel',
  isReferential: true
})
